import { Component, Input, OnInit } from '@angular/core';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {

  @Input()
  public Parent : Busyable | null = null;
  @Input()
  Mode : string = "spinner";
  @Input()
  public AlwaysOn : boolean = false;

  public Visible : boolean = false;

  constructor() { }

  ngOnInit(): void {

    this.Parent?.LoadingStarted.subscribe(x => {
      this.Visible = true;
    });
    this.Parent?.LoadingEnded.subscribe(x => {
      this.Visible = false || this.AlwaysOn;
    });

    if(this.Parent != null)
      this.Visible = this.Parent.IsLoading || this.AlwaysOn;
  }

}
